export default function LexiqLogo({ size = 44, className = "" }) {
  return (
    <img
      src="/lexiq-icon-192.png"
      alt="LexIQ — العَدل أساس المُلك"
      width={size}
      height={size}
      className={`object-contain ${className}`}
      style={{ borderRadius: size >= 64 ? "14%" : "10%" }}
    />
  );
}
